<script setup lang="ts">
    import { onClickOutside } from '@vueuse/core';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';
    const { $theme } = useNuxtApp();

    const { tenant } = useAuthStore();
    const props = defineProps<FormInputProps>();
    const inputData: FormInputData = useFormInput(props);
    const focused = ref(false);

    const prefixInput = ref(null);
    onClickOutside(prefixInput, (event) => (focused.value = false));

    const suggestions = computed<string[]>(() => {
        if (!focused.value || !inputData.model.value || inputData.model.value.length < 1) {
            return [];
        }
        console.log('SUGGESTIONS', inputData.model.value);

        const providers = ['Mr', 'M', 'Mr-M', 'M-Mr', 'Dr', 'Prof', 'Master', 'mr', 'm', 'mr-m', 'm-mr', 'dr', 'prof', 'master'];

        return providers.filter((prefix) => prefix.startsWith(inputData.model.value) && prefix !== inputData.model.value);
    });
</script>

<template>
    <FormElement :input-data="inputData">
        <div
            ref="prefixInput"
            class="relative"
        >
            <input
                :id="inputData.inputId.value"
                v-model="inputData.model.value"
                :class="[inputData.className.value]"
                :name="inputData.props.inputName"
                :placeholder="inputData.placeholder.value"
                type="text"
                :disabled="inputData.props.disabled"
                @focus="focused = true"
            />
            <div
                v-if="suggestions.length > 0"
                :class="$theme('submenu.container.default', 'w-full')"
            >
                <div :class="$theme('submenu.items')">
                    <a
                        v-for="suggestion in suggestions"
                        :key="suggestion"
                        href="#"
                        :class="$theme('submenu.item')"
                        @click.prevent="inputData.model.value = suggestion"
                    >
                        {{ suggestion }}
                    </a>
                </div>
            </div>
        </div>
    </FormElement>
</template>
